import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';

interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  mainText?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xs' | 'xl' | undefined | false;
  customContent?: React.ReactNode;
  disableConfirm?: boolean;
  onConfirm: () => void;
  handleClose: () => void;
  onCancel?: () => void;
  enableMainTextLineBrake?: boolean;
}
const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  title,
  mainText,
  customContent,
  disableConfirm,
  open,
  maxWidth = 'sm',
  onConfirm,
  onCancel,
  handleClose,
  enableMainTextLineBrake,
}) => {
  return (
    <Dialog open={open} maxWidth={maxWidth} keepMounted onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText
          id="alert-dialog-slide-description"
          style={enableMainTextLineBrake ? { whiteSpace: 'pre-wrap' } : {}}
        >
          {customContent || mainText}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'flex-end', padding: 16 }}>
        <Button onClick={onCancel} color="primary">
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          disabled={disableConfirm}
          variant="contained"
          color="primary"
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
